const FancyArrowUp = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.502 6.25612C12.8427 6.88495 13.2273 7.41934 13.6859 7.87829C14.6362 8.82941 15.8572 9.40993 17.5214 9.88668C17.7868 9.96273 18.0637 9.80918 18.1397 9.54371C18.2158 9.27825 18.0622 9.0014 17.7968 8.92535C16.2086 8.47036 15.1726 7.95138 14.3933 7.17147C13.61 6.38757 13.0392 5.2935 12.4769 3.59225C12.4073 3.38154 12.211 3.24827 12.0005 3.24903C11.79 3.24827 11.5937 3.38154 11.524 3.59225C10.9617 5.2935 10.391 6.38757 9.60769 7.17147C8.82842 7.95138 7.79242 8.47036 6.20422 8.92535C5.93876 9.0014 5.78521 9.27825 5.86126 9.54371C5.93731 9.80918 6.21416 9.96273 6.47963 9.88668C8.14377 9.40993 9.36475 8.82941 10.3151 7.87829C10.775 7.41803 11.1605 6.88189 11.502 6.25072L11.502 20.249C11.502 20.5252 11.7258 20.749 12.002 20.749C12.2781 20.749 12.502 20.5252 12.502 20.249L12.502 6.25612Z"
        fill="#646464"
      />
    </svg>
  )
}

export default FancyArrowUp
